// Fund cascade dispatcher. Admin setting `useNewFundCascade` (default OFF)
// picks the iter163 anchor-based cascade (fundCascadeNew) or the previous
// behaviour (fundCascadeLegacy), so LIVE can switch instantly either way.
import * as NEW from "./fundCascadeNew";
import * as OLD from "./fundCascadeLegacy";

const LS_KEY = "mdm.useNewFundCascade";
let useNew = (() => { try { return localStorage.getItem(LS_KEY) === "1"; } catch { return false; } })();
export function setUseNewFundCascade(v) {
  const next = !!v;
  try { localStorage.setItem(LS_KEY, next ? "1" : "0"); } catch { /* ignore */ }
  const changed = next !== useNew;
  useNew = next;
  return changed;
}
export function isNewFundCascade() { return useNew; }

export const pickAnchor = NEW.pickAnchor;
export const consumedForMonth = (...a) => (useNew ? NEW : OLD).consumedForMonth(...a);
export const cascadeClosing = (...a) => (useNew ? NEW : OLD).cascadeClosing(...a);
export const cascadeOpening = (...a) => (useNew ? NEW : OLD).cascadeOpening(...a);
export const cascadeMonth = (...a) => NEW.cascadeMonth(...a);

export async function buildFullLedger(schoolId, balances, cache) {
  if (useNew) return NEW.buildFullLedger(schoolId, balances, cache);
  const legacy = await OLD.buildFullLedger(schoolId, balances);
  const out = new Map();
  [...legacy.entries()]
    .map(([k, v]) => { const [y, m] = k.split("-").map(Number); return [k, { ...v, year: y, month: m, saved: true }]; })
    .sort((a, b) => a[1].year - b[1].year || a[1].month - b[1].month)
    .forEach(([k, v]) => out.set(k, v));
  return out;
}
